import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {volumeSummaryMetricsByIdByCompetency} from '/redux/selector/metric.clients.selector';
import {withProps} from '/util/selector.util';

import Notifications from './Notifications';

const getCompetencyByUserId = withProps({coachId: userId})(competencyById);
interface StateProps {
  metrics: any;
  currentUserCompetency: any;
}

export default connect<StateProps>(
  createStructuredSelector({
    metrics: withProps({
      coachId: userId,
      competency: getCompetencyByUserId,
    })(volumeSummaryMetricsByIdByCompetency),
    currentUserCompetency: getCompetencyByUserId,
  }),
)(Notifications);
